import React from 'react';
import PropTypes from 'prop-types';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import DesktopColumnsMobileStack from 'components/consumer/DesktopColumnsMobileStack/DesktopColumnsMobileStack';

const FluidTextBlocksContainer = ({ children }) => (
  <FixedWidthContainer>
    <DesktopColumnsMobileStack>{children}</DesktopColumnsMobileStack>
  </FixedWidthContainer>
);

FluidTextBlocksContainer.propTypes = {
  children: PropTypes.node,
};

export default FluidTextBlocksContainer;
